module.exports = __webpack_public_path__ + "static/media/setting-3.48cc27c5.svg";